import React from "react";
import { StructuredText } from "react-datocms";
import dynamic from "next/dynamic";

const ImageUI = dynamic(() => import("@/common/UI/Image"));
const Link = dynamic(() => import("@/common/UI/Link"));

const IconBoxCard = (props) => {
  const {
    bg,
    icon,
    title,
    info,
    btnUrl,
    btnText,
    bgColor,
    imgTitle,
    alt,
    target,
    iconAlt,
    iconTitle,
  } = props;
  return (
    <div
      className={
        `relative text-center flex flex-col h-full items-center gradient ` +
        bgColor
      }
    >
      {bg && (
        <div className="cover-image">
          <ImageUI src={bg?.src || bg} title={imgTitle} alt={alt} />
        </div>
      )}

      <div className="px-10 py-16 relative z-10 flex flex-col h-full justify-center items-center">
        <div className="relative">
          {icon && (
            <ImageUI
              alt={iconAlt}
              title={iconTitle}
              src={icon?.src || icon}
              width={200}
              height={50}
              className="object-contain"
            />
          )}
        </div>
        <div className="text-white">
          <h2 className="h2-web my-4">{title}</h2>
          {typeof info === "string" ? (
            <h3 className="h3-web">{info}</h3>
          ) : (
            <h3 className="h3-web structure-format">
              <StructuredText data={info} />
            </h3>
          )}

          <Link
            href={btnUrl || "/"}
            target={target}
            className="btn inline-block border-white mt-5 tracking-widest font-bold px-8"
          >
            {btnText}
          </Link>
        </div>
      </div>
    </div>
  );
};
export default IconBoxCard;
